import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { SectionContent } from '../SectionContent';

interface SectionAccordionProps {
  section: string;
  sectionData: any;
  isExpanded: boolean;
  onToggleSection: (sectionKey: string) => void;
  expandedFolder: string | null;
  toggleFolder: (folderId: string) => void;
  getCodeSetInstanceCount: (itemId: string) => number;
  handleItemSelection: (item: any) => void;
  allowMultiple: boolean;
  isLimitReached: boolean;
  handleModeToggle?: (item: any, mode: 'treating' | 'sending') => void;
  getActiveModesForCodeSet?: (itemId: string) => ('treating' | 'sending')[];
  isReferringDisabled?: boolean;
}

const SectionAccordion: React.FC<SectionAccordionProps> = ({
  section,
  sectionData,
  isExpanded,
  onToggleSection,
  expandedFolder,
  toggleFolder,
  getCodeSetInstanceCount,
  handleItemSelection,
  allowMultiple,
  isLimitReached,
  handleModeToggle,
  getActiveModesForCodeSet,
  isReferringDisabled = false,
}) => {
  const lowercaseKey = section.toLowerCase();

  return (
    <div
      className={
        allowMultiple
          ? 'col-span-full grid grid-cols-subgrid'
          : 'self-stretch flex flex-col'
      }
    >
      {allowMultiple ? (
        <div
          className="col-span-full grid grid-cols-subgrid bg-background-body cursor-pointer hover:bg-neutral-100"
          onClick={() => onToggleSection(lowercaseKey)}
          data-testid={`section-header-${lowercaseKey}`}
        >
          <div className="h-10 px-4 flex items-center gap-2">
            <div className="w-5 h-5 flex items-center justify-center">
              <Icon
                icon={faChevronRight}
                className={`w-3 h-1.5 text-neutral-600 transition-all duration-300 ${
                  isExpanded ? 'rotate-90' : 'rotate-0'
                }`}
              />
            </div>
            <div className="justify-start text-primary text-sm font-semibold font-['Inter'] leading-tight">
              {section}
            </div>
          </div>
          {isExpanded && (
            <>
              <div className="h-10 px-1 flex items-center justify-start text-xs font-medium font-['Inter'] text-neutral-500">
                Treating
              </div>
              <div
                className={`h-10 pl-1 pr-3 flex items-center justify-start text-xs font-medium font-['Inter'] text-neutral-500 ${
                  isReferringDisabled ? 'opacity-50' : ''
                }`}
              >
                Referring
              </div>
            </>
          )}
        </div>
      ) : (
        <div
          className="h-10 px-4 self-stretch bg-background-body flex items-center gap-2 cursor-pointer hover:bg-neutral-100"
          onClick={() => onToggleSection(lowercaseKey)}
          data-testid={`section-header-${lowercaseKey}`}
        >
          <div className="flex-1 flex justify-start items-center gap-2">
            <div className="w-5 h-5 flex items-center justify-center">
              <Icon
                icon={faChevronRight}
                className={`w-3 h-1.5 text-neutral-600 transition-all duration-300 ${
                  isExpanded ? 'rotate-90' : 'rotate-0'
                }`}
              />
            </div>
            <div className="justify-start text-primary text-sm font-semibold font-['Inter'] leading-tight">
              {section}
            </div>
          </div>
        </div>
      )}

      {isExpanded && (
        <div
          className={`w-full overflow-y-auto overflow-x-hidden max-h-80 ${allowMultiple ? 'col-span-full grid grid-cols-subgrid' : 'px-2'}`}
        >
          <SectionContent
            sectionData={sectionData}
            expandedFolder={expandedFolder}
            toggleFolder={toggleFolder}
            getCodeSetInstanceCount={getCodeSetInstanceCount}
            handleItemSelection={handleItemSelection}
            allowMultiple={allowMultiple}
            isLimitReached={isLimitReached}
            handleModeToggle={handleModeToggle}
            getActiveModesForCodeSet={getActiveModesForCodeSet}
            isReferringDisabled={isReferringDisabled}
          />
        </div>
      )}
    </div>
  );
};

export default SectionAccordion;
